/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */
import DatePicker from 'tui-date-picker';
import AutoComplete from './autocomplete';
import CustomSelect from './customselect';

const inputs = () => {
  DatePicker.localeTexts.pl = {
    titles: {
      // days
      DD: [
        'Niedziela',
        'Poniedziałek',
        'Wtorek',
        'Środa',
        'Czwartek',
        'Piątek',
        'Sobota',
      ],
      // daysShort
      D: ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
      // months
      MMMM: [
        'Styczeń',
        'Luty',
        'Marzec',
        'Kwiecień',
        'Maj',
        'Czerwiec',
        'Lipiec',
        'Sierpień',
        'Wrzesień',
        'Październik',
        'Listopad',
        'Grudzień',
      ],
      // monthsShort
      MMM: [
        'Sty',
        'Lut',
        'Mar',
        'Kwi',
        'Maj',
        'Cze',
        'Lip',
        'Sie',
        'Wrz',
        'Paź',
        'Lis',
        'Gru',
      ],
    },
    titleFormat: 'MMMM yyyy',
    todayFormat: 'DD, dd.MM.yyyy',
    date: 'Data',
    time: 'Czas',
  };

  if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
    const calendars = document.querySelectorAll('.c-input--date');
    calendars.forEach(element => {
      element.setAttribute('type', 'text');
      const container = element.parentElement.querySelector('.js-calendar');
      const datepicker = new DatePicker(container, {
        language: 'pl',
        input: {
          element,
        },
      });
    });
  }
  document.querySelectorAll('.js-password').forEach(element => {
    element.addEventListener('click', e => {
      const input = e.target.parentElement.querySelector('input');
      input.setAttribute(
        'type',
        input.getAttribute('type') === 'text' ? 'password' : 'text',
      );
    });
  });
  document.querySelectorAll('.js-select').forEach(element => {
    const args = {
      elem: element,
    };
    const select = new CustomSelect(args);
    // if (
    //   /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
    // ) {
    element.addEventListener('change', e => {
      e.target.parentElement.querySelector(
        '.c-select__title',
      ).innerText = e.target.parentElement.querySelector(
        `option[value="${e.target.value}"]`,
      ).innerText;
    });
    // }
    element.addEventListener('change', e => {
      if (e.target.classList.contains('js-select-link')) {
        document
          .querySelector(`.js-select-target[data-sort="${e.target.value}"]`)
          .click();
      }
      if (e.target.classList.contains('js-select-language')) {
        document
          .querySelector(`.js-select-target[data-language="${e.target.value}"]`)
          .click();
      }
    });
  });
  document.querySelectorAll('.js-textarea').forEach(element => {
    element.addEventListener('keyup', e => {
      const counter = e.target.parentElement.querySelector(
        '.js-counter-current',
      );
      if (counter) {
        counter.innerText = e.target.value.length;
      }
    });
  });
  document.querySelectorAll('.js-autocomplete').forEach(element => {
    const autocomplete = new AutoComplete({
      selector: element,
      minChars: 1,
      source(term, suggest) {
        const termLC = term.toLowerCase();
        const choices = ['ActionScript', 'AppleScript', 'Asp'];
        const matches = [];
        for (let i = 0; i < choices.length; i += 1)
          if (~choices[i].toLowerCase().indexOf(termLC))
            matches.push(choices[i]);
        if (matches.length < 5) {
          suggest(matches);
        }
      },
    });
  });

  function readableBytes(bytes) {
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    // eslint-disable-next-line no-restricted-properties
    return `${(bytes / Math.pow(1024, i)).toFixed(2) * 1} ${sizes[i]}`;
  }
  document.querySelectorAll('.js-file').forEach(element => {
    element.addEventListener('change', e => {
      const input = e.target;
      if (input.files) {
        input.parentElement.classList.add('is-chosen');
        if (input.classList.contains('simple-file')) {
          input.parentElement.parentElement.classList.add('is-chosen');
          const inf = input.parentElement.parentElement.querySelector(
            '.js-file-inf',
          );
          inf.innerHTML = `<span class="c-filelist__name">${
            input.files[0].name
          }</span>`;
          const hiddenNextFiles = document.querySelectorAll(
            '.wrapper-file-input.hidden',
          );
          if (hiddenNextFiles) {
            hiddenNextFiles.forEach((item, index) => {
              if (index === 0) {
                item.classList.remove('hidden');
              }
            });
          }
        } else {
          const list = input.parentElement.parentElement.querySelector(
            '.js-filelist',
          );
          list.innerHTML = '';
          for (let i = 0; i < input.files.length; i += 1) {
            list.innerHTML += `<li class="c-filelist__item o-list-bare__item">
                <span class="c-filelist__name">${input.files[i].name}</span>
                <span class="c-filelist__size">${readableBytes(
                  input.files[i].size,
                )}</span>
            </li>`;
          }
        }
      } else {
        input.parentElement.classList.remove('is-chosen');
      }
    });
  });
  document.querySelectorAll('.js-toggle-labels').forEach(element => {
    element.addEventListener('click', e => {
      e.target.classList.toggle('is-active');
      e.target.parentElement.parentElement
        .querySelectorAll(
          '.c-label:not(.c-label--toggleable):not(.c-label--group)',
        )
        .forEach(el => {
          el.classList.toggle('is-toggled');
        });
    });
  });
  document.querySelectorAll('.js-toggle-all').forEach(element => {
    element.addEventListener('change', e => {
      if (e.target.classList.contains('js-toggle-cf7')) {
        e.target
          .closest('.multicheckbox-wrapper-js')
          .querySelectorAll(' input')
          .forEach(el => {
            // eslint-disable-next-line no-param-reassign
            el.checked = e.target.checked;
          });
      } else {
        e.target.parentElement.parentElement.parentElement
          .querySelectorAll(' input')
          .forEach(el => {
            // eslint-disable-next-line no-param-reassign
            el.checked = e.target.checked;
          });
      }
    });
  });
  document.querySelectorAll('.js-harmony-item').forEach(element => {
    element.addEventListener('click', e => {
      e.target.parentElement.classList.toggle('is-active');
    });
  });
  document.querySelectorAll('.js-show-input').forEach(element => {
    element.addEventListener('change', e => {
      const parentEl = e.target.closest('.c-label__container');
      if (e.target.checked) {
        parentEl.querySelector('.c-hidden-input').classList.add('is-active');
      } else {
        parentEl.querySelector('.c-hidden-input').classList.remove('is-active');
      }
    });
  });
};

export default inputs;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/inputs.js